module.exports = __webpack_public_path__ + "static/img/PRODUCT CARD_ANTI-BACTERIAL PU_mobile.da39ca99.jpg";